var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotPasswordDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 575,
    viewBox: "0 0 650 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    opacity: 0.0528274,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650 173.93C650 77.8709 571.829 0 475.402 0C378.974 0 300.804 77.8709 300.804 173.93C300.804 269.988 378.974 347.859 475.402 347.859C571.829 347.859 650 269.988 650 173.93ZM366.074 173.93C366.074 113.781 415.022 65.0204 475.402 65.0204C535.782 65.0204 584.729 113.781 584.729 173.93C584.729 234.078 535.782 282.839 475.402 282.839C415.022 282.839 366.074 234.078 366.074 173.93Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval_2",
    opacity: 0.14102,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.993 275.795C104.993 248.563 82.8328 226.488 55.4966 226.488C28.1604 226.488 6 248.563 6 275.795C6 303.027 28.1604 325.102 55.4966 325.102C82.8328 325.102 104.993 303.027 104.993 275.795ZM38.6351 275.795C38.6351 266.518 46.1843 258.998 55.4966 258.998C64.809 258.998 72.3581 266.518 72.3581 275.795C72.3581 285.072 64.809 292.592 55.4966 292.592C46.1843 292.592 38.6351 285.072 38.6351 275.795Z",
    fill: "#8BF78F"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3",
    cx: 208.338,
    cy: 433.469,
    rx: 97.9054,
    ry: 97.5306,
    fill: "#7367F0",
    fillOpacity: 0.0612161
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_4",
    opacity: 0.14102,
    cx: 175.702,
    cy: 92.1121,
    rx: 34.8108,
    ry: 34.6776,
    fill: "#CEF5FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval_5",
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 585.818,
    cy: 433.469,
    rx: 34.8108,
    ry: 34.6776,
    fill: "#7367F0",
    fillOpacity: 0.135927
  }))), /*#__PURE__*/React.createElement("g", {
    id: "File Organizer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.539 144.137C208.539 130.254 219.793 119 233.676 119H403.481C417.364 119 428.618 130.254 428.618 144.137V547.336C428.618 561.218 417.364 572.473 403.481 572.473H233.676C219.793 572.473 208.539 561.218 208.539 547.336V144.137Z",
    fill: "#C4E3E7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.477 146.66C216.477 136.431 224.769 128.138 234.999 128.138H265.888C266.701 128.138 267.366 128.784 267.39 129.597V129.597C267.559 135.419 272.328 140.051 278.153 140.051H358.284C364.108 140.051 368.877 135.419 369.047 129.597V129.597C369.07 128.784 369.736 128.138 370.548 128.138H401.438C411.667 128.138 419.96 136.431 419.96 146.66V542.105C419.96 552.334 411.667 560.627 401.438 560.627H234.999C224.769 560.627 216.477 552.334 216.477 542.105V146.66Z",
    fill: "#161D31"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 216,
    y: 128,
    width: 204,
    height: 433
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.477 146.66C216.477 136.431 224.769 128.138 234.999 128.138H265.888C266.701 128.138 267.366 128.784 267.39 129.597V129.597C267.559 135.419 272.328 140.051 278.153 140.051H358.284C364.108 140.051 368.877 135.419 369.047 129.597V129.597C369.07 128.784 369.736 128.138 370.548 128.138H401.438C411.667 128.138 419.96 136.431 419.96 146.66V542.105C419.96 552.334 411.667 560.627 401.438 560.627H234.999C224.769 560.627 216.477 552.334 216.477 542.105V146.66Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_6",
    opacity: 0.0987723,
    cx: 293.623,
    cy: 391.368,
    rx: 17.453,
    ry: 17.3276,
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_7",
    opacity: 0.14102,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.068 374.04C444.606 374.04 482.333 411.496 482.333 457.7C482.333 503.904 444.606 541.359 398.068 541.359C351.53 541.359 313.803 503.904 313.803 457.7C313.803 411.496 351.53 374.04 398.068 374.04ZM398.068 410.59C371.862 410.59 350.618 431.682 350.618 457.7C350.618 483.717 371.862 504.809 398.068 504.809C424.274 504.809 445.518 483.717 445.518 457.7C445.518 431.682 424.274 410.59 398.068 410.59Z",
    fill: "#C8F5D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.264 208.075C241.264 204.934 243.809 202.389 246.949 202.389H391.019C394.159 202.389 396.704 204.934 396.704 208.075V208.075C396.704 211.215 394.159 213.76 391.019 213.76H246.949C243.809 213.76 241.264 211.215 241.264 208.075V208.075Z",
    fill: "#68DE9E",
    fillOpacity: 0.642073
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M330.508 126.939C332.39 126.939 333.916 128.394 333.916 130.188C333.916 131.942 332.457 133.372 330.632 133.435L330.508 133.437H291.962C290.08 133.437 288.554 131.982 288.554 130.188C288.554 128.433 290.013 127.004 291.838 126.941L291.962 126.939H330.508Z",
    fill: "#56CDD9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M344.322 126.397C346.205 126.397 347.731 127.913 347.731 129.782C347.731 131.609 346.272 133.099 344.447 133.164L344.322 133.166H344.143C342.261 133.166 340.734 131.651 340.734 129.782C340.734 127.954 342.193 126.465 344.018 126.4L344.143 126.397H344.322Z",
    fill: "#56CDD9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.72 276.463C222.72 274.254 224.511 272.463 226.72 272.463L234.313 272.463C236.523 272.463 238.313 274.254 238.313 276.463V279.966C238.313 280.639 238.859 281.185 239.533 281.185H289.542C291.751 281.185 293.542 282.976 293.542 285.185V327.883C293.542 330.092 291.751 331.883 289.542 331.883H226.72C224.511 331.883 222.72 330.092 222.72 327.883V276.463Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.536 277.616C239.631 277.025 240.141 276.59 240.739 276.59H295.061C295.812 276.59 296.384 277.261 296.265 278.003L288.105 328.794C288.01 329.385 287.5 329.82 286.901 329.82H232.579C231.829 329.82 231.256 329.149 231.375 328.408L239.536 277.616Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.086 290.108C300.604 290.108 302.496 292.406 302.012 294.877L295.899 326.091C295.163 329.845 291.873 332.554 288.048 332.554H227.579C225.061 332.554 223.17 330.256 223.654 327.785L229.767 296.57C230.502 292.816 233.792 290.108 237.617 290.108L298.086 290.108Z",
    fill: "#FFCC7B"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142 222.468C142 219.154 144.686 216.468 148 216.468H181.667L194.359 229.463V272.197C194.359 275.511 191.673 278.197 188.359 278.197H148C144.686 278.197 142 275.511 142 272.197V222.468Z",
    fill: "#B7B1FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.099 257.505V240.458C176.099 238.647 174.714 237.262 172.903 237.262H167.575C166.935 237.262 166.509 237.688 166.509 238.327C166.509 238.966 166.935 239.393 167.575 239.393H172.903C173.542 239.393 173.968 239.819 173.968 240.458V257.505C173.968 258.144 173.542 258.57 172.903 258.57H167.575C166.935 258.57 166.509 258.996 166.509 259.636C166.509 260.275 166.935 260.701 167.575 260.701H172.903C174.714 260.701 176.099 259.316 176.099 257.505ZM169.599 248.555C169.706 248.875 169.706 249.194 169.599 249.408C169.599 249.514 169.493 249.621 169.386 249.727L165.124 253.989C164.91 254.202 164.591 254.308 164.378 254.308C164.165 254.308 163.845 254.202 163.632 253.989C163.205 253.563 163.205 252.923 163.632 252.497L166.083 250.047H155.853C155.213 250.047 154.787 249.621 154.787 248.981C154.787 248.342 155.213 247.916 155.853 247.916H166.083L163.632 245.465C163.205 245.039 163.205 244.4 163.632 243.974C164.058 243.548 164.697 243.548 165.124 243.974L169.386 248.236C169.439 248.289 169.466 248.342 169.493 248.395C169.519 248.449 169.546 248.502 169.599 248.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 237,
    width: 23,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.099 257.505V240.458C176.099 238.647 174.714 237.262 172.903 237.262H167.575C166.935 237.262 166.509 237.688 166.509 238.327C166.509 238.966 166.935 239.393 167.575 239.393H172.903C173.542 239.393 173.968 239.819 173.968 240.458V257.505C173.968 258.144 173.542 258.57 172.903 258.57H167.575C166.935 258.57 166.509 258.996 166.509 259.636C166.509 260.275 166.935 260.701 167.575 260.701H172.903C174.714 260.701 176.099 259.316 176.099 257.505ZM169.599 248.555C169.706 248.875 169.706 249.194 169.599 249.408C169.599 249.514 169.493 249.621 169.386 249.727L165.124 253.989C164.91 254.202 164.591 254.308 164.378 254.308C164.165 254.308 163.845 254.202 163.632 253.989C163.205 253.563 163.205 252.923 163.632 252.497L166.083 250.047H155.853C155.213 250.047 154.787 249.621 154.787 248.981C154.787 248.342 155.213 247.916 155.853 247.916H166.083L163.632 245.465C163.205 245.039 163.205 244.4 163.632 243.974C164.058 243.548 164.697 243.548 165.124 243.974L169.386 248.236C169.439 248.289 169.466 248.342 169.493 248.395C169.519 248.449 169.546 248.502 169.599 248.555Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\xF0\x9F\x8E\xA8 Icon Color",
    x: 152.656,
    y: 236.196,
    width: 25.5748,
    height: 25.5701,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    opacity: 0.33996,
    d: "M194.358 229.463H184.666C183.009 229.463 181.666 228.12 181.666 226.463V216.468L194.358 229.463Z",
    fill: "#7367F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.907 382.748C164.907 379.434 167.594 376.748 170.907 376.748H233.082C236.396 376.748 239.082 379.434 239.082 382.748V432.477C239.082 435.791 236.396 438.477 233.082 438.477H170.907C167.594 438.477 164.907 435.791 164.907 432.477V382.748Z",
    fill: "#6FD9E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.841 405.159H208.598V401.43C208.598 397.328 205.241 393.972 201.138 393.972C197.036 393.972 193.679 397.328 193.679 401.43V405.159H192.436C190.322 405.159 188.706 406.774 188.706 408.888V417.589C188.706 419.702 190.322 421.317 192.436 421.317H209.841C211.954 421.317 213.57 419.702 213.57 417.589V408.888C213.57 406.774 211.954 405.159 209.841 405.159ZM196.165 401.43C196.165 398.695 198.403 396.458 201.138 396.458C203.873 396.458 206.111 398.695 206.111 401.43V405.159H196.165V401.43ZM209.841 418.831C210.587 418.831 211.084 418.334 211.084 417.589V408.888C211.084 408.142 210.587 407.645 209.841 407.645H192.436C191.69 407.645 191.192 408.142 191.192 408.888V417.589C191.192 418.334 191.69 418.831 192.436 418.831H209.841Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 188,
    y: 393,
    width: 26,
    height: 29
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.841 405.159H208.598V401.43C208.598 397.328 205.241 393.972 201.138 393.972C197.036 393.972 193.679 397.328 193.679 401.43V405.159H192.436C190.322 405.159 188.706 406.774 188.706 408.888V417.589C188.706 419.702 190.322 421.317 192.436 421.317H209.841C211.954 421.317 213.57 419.702 213.57 417.589V408.888C213.57 406.774 211.954 405.159 209.841 405.159ZM196.165 401.43C196.165 398.695 198.403 396.458 201.138 396.458C203.873 396.458 206.111 398.695 206.111 401.43V405.159H196.165V401.43ZM209.841 418.831C210.587 418.831 211.084 418.334 211.084 417.589V408.888C211.084 408.142 210.587 407.645 209.841 407.645H192.436C191.69 407.645 191.192 408.142 191.192 408.888V417.589C191.192 418.334 191.69 418.831 192.436 418.831H209.841Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon Color_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\xF0\x9F\x8E\xA8 Icon Color_2",
    x: 186.22,
    y: 392.729,
    width: 29.8373,
    height: 29.8318,
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    d: "M229.265 185.646C229.265 182.333 231.951 179.646 235.265 179.646H297.44C300.754 179.646 303.44 182.333 303.44 185.646V235.376C303.44 238.69 300.754 241.376 297.44 241.376H235.265C231.951 241.376 229.265 238.69 229.265 235.376V185.646Z",
    fill: "#BAF3C4"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 179,
    width: 75,
    height: 63
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    d: "M229.265 185.646C229.265 182.333 231.951 179.646 235.265 179.646H297.44C300.754 179.646 303.44 182.333 303.44 185.646V235.376C303.44 238.69 300.754 241.376 297.44 241.376H235.265C231.951 241.376 229.265 238.69 229.265 235.376V185.646Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_8",
    cx: 261.989,
    cy: 202.389,
    rx: 9.8173,
    ry: 9.74675,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_9",
    cx: 239.627,
    cy: 252.747,
    rx: 35.4514,
    ry: 35.1966,
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_10",
    cx: 303.986,
    cy: 244.625,
    rx: 41.9962,
    ry: 41.153,
    fill: "#69E09E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_12",
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.477 164.778C327.455 159.239 331.939 154.738 337.477 154.738H447.72C453.227 154.738 457.698 159.191 457.72 164.698L458.295 309.31C458.317 314.848 453.833 319.35 448.295 319.35H338.052C332.545 319.35 328.074 314.897 328.052 309.39L327.477 164.778Z",
    fill: "#313A53"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13",
    opacity: 0.33996,
    d: "M368.889 259.786C368.889 257.992 370.343 256.537 372.138 256.537H413.635C415.43 256.537 416.884 257.992 416.884 259.786V259.786C416.884 261.581 415.43 263.035 413.635 263.035H372.138C370.343 263.035 368.889 261.581 368.889 259.786V259.786Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14",
    opacity: 0.33996,
    d: "M357.98 277.114C357.98 275.32 359.435 273.865 361.229 273.865H424.543C426.338 273.865 427.792 275.32 427.792 277.114V277.114C427.792 278.908 426.338 280.363 424.543 280.363H361.229C359.435 280.363 357.98 278.908 357.98 277.114V277.114Z",
    fill: "#7367F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval_11",
    filter: "url(#filter3_dd)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.968,
    cy: 207.357,
    rx: 25.1704,
    ry: 25.5449,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.443 206.51C396.999 206.51 399.882 203.648 399.882 200.117C399.882 196.587 396.999 193.725 393.443 193.725C389.887 193.725 387.004 196.587 387.004 200.117C387.004 203.648 389.887 206.51 393.443 206.51ZM392.631 208.32C387.35 208.32 383.069 212.601 383.069 217.881C383.069 218.485 383.559 218.974 384.162 218.974H402.724C403.327 218.974 403.817 218.485 403.817 217.881C403.817 212.601 399.536 208.32 394.255 208.32H392.631Z",
    fill: "#7367F0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Wom3.5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.545 340.072C517.545 340.072 505.347 352.052 506.095 353.223C506.843 354.403 512.99 351.663 512.99 351.663C512.99 351.663 505.321 364.247 506.899 365.214C508.476 366.181 516.545 364.223 519.019 361.629C521.494 359.035 525.312 345.945 525.312 345.945L543.865 311.45L530.41 306.827L517.545 340.072Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.088 276.306C510.211 284.208 527.455 306.729 527.455 306.729L526.198 311.222L542.045 322.008C542.045 322.008 546.547 309.66 546.938 307.923C548.226 302.193 522.192 265.626 516.362 260.342C507.184 252.022 497.26 264.229 505.088 276.306Z",
    fill: "#FD8715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M531.576 312.707C531.872 312.135 527.48 306.648 527.48 306.648L526.736 309.316C526.736 309.316 531.281 313.28 531.576 312.707Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 70",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526.1 309.714L542.936 322.479L539.184 330.734L524.464 314.478L526.1 309.714Z",
    fill: "#FFEDC2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.472 542.024L514.537 557.842L526.524 558.152L524.271 542.024H515.472Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.092 548.256C527.092 548.256 526.756 557.782 528.743 561.108C530.743 564.433 531.348 567.012 531.437 569.001C531.531 571.133 531.328 573.065 531.328 573.065H511.488C511.488 573.065 510.991 563.042 512.305 561.152C513.619 559.263 514.481 559.23 514.481 557.56C514.492 555.89 514.776 548.318 514.776 548.318L527.092 548.256Z",
    fill: "#391B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M473.239 330.841L504.336 327.485L504.793 327.906C507.009 330.003 516.641 339.739 519.408 353.048C524.633 378.173 517.64 424.578 517.795 434.753C517.943 444.929 522.786 451.069 524.799 465.456C526.811 479.843 527.001 544.143 527.001 544.143C521.665 547.283 516.97 547.507 510.607 543.955L473.239 330.841Z",
    fill: "#4E3319"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.016 489.256L473.239 330.841L490.529 328.975C491.299 384.008 502.052 458.397 501.016 489.256Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.609 540.361L469.387 540.526C469.387 540.526 470.059 551.06 466.128 554.628L465.913 554.815C461.168 558.764 479.476 557.339 479.476 557.339L479.609 540.361Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.151 548.573L479.857 573.056L472.578 573.061L472.515 567.028C472.515 567.028 470.219 572.653 466.71 572.978C463.191 573.303 447.509 573.104 447.509 573.104C447.509 573.104 446.206 567.456 454.012 564.891C460.505 562.759 467.684 548.573 467.684 548.573H480.151Z",
    fill: "#391B0B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.814 333.019L492.733 331.844L492.994 332.323C494.688 335.514 503.972 354.195 501.106 375.428C497.082 405.232 486.853 440.171 486.352 445.509C485.459 455.025 487.245 461.915 487.977 471.744C488.709 481.573 485.185 543.391 485.185 543.391C480.003 546.485 473.837 547.092 465.998 543.484C465.998 543.484 458.921 459.518 458.869 446.229C458.817 432.941 457.814 333.019 457.814 333.019Z",
    fill: "#604021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465 365.255L464.768 367.463C462.441 390.748 462.458 440.198 463.36 447.824L463.483 448.807C464.483 457.412 464.515 479.26 463.58 514.35L462.364 499.208C460.058 470.072 458.893 452.412 458.869 446.229L458.827 439.83C458.626 413.956 457.814 333.018 457.814 333.018L465.179 332.771C465.966 345.547 465.906 356.375 465 365.255Z",
    fill: "white",
    fillOpacity: 0.192499
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.13 222.653C466.834 223.12 467.138 230.619 472.368 231.011C473.437 238.24 477.25 241.684 481.898 242.083L481.64 253.018L502.199 253.006C502.199 253.006 496.41 245.281 496.699 234.706C496.987 224.13 496.505 214.196 496.505 214.196L469.876 214.67L471.13 222.653Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.195 223.215C475.199 221.25 478.896 229.709 482.725 235.589C486.554 241.468 496.474 240.469 497.841 235.589C503.017 224.899 507.478 210.367 501.438 209.174C500.587 193.726 459.859 197.373 470.195 223.215Z",
    fill: "#8B5030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.141 203.079H489.281H489.169L489.095 203.162C481.246 211.86 479.5 224.681 483.191 236.235C483.447 236.556 483.724 236.853 484.017 237.126C479.932 225.481 481.513 212.381 489.392 203.579H498.734C498.544 203.406 498.346 203.24 498.141 203.079Z",
    fill: "black",
    fillOpacity: 0.199355
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_12",
    cx: 492.697,
    cy: 203.329,
    rx: 4.90865,
    ry: 4.87338,
    fill: "#FB9934"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M465.736 255.135C461.149 261.825 453.505 284.53 453.071 289.637C452.583 295.529 458.945 304.915 459.049 313.444C459.142 321.974 454.304 347.658 455.758 350.058C457.2 352.457 498.554 363.079 501.252 363.022C503.939 362.964 520.901 348.507 518.773 343.511C516.633 338.515 506.7 326.099 507.712 319.292C508.712 312.485 514.521 287.36 517.405 278.809C520.278 270.257 519.32 261.279 513.959 257.6C511.305 255.779 504.226 250.606 491.619 250.63C479.012 250.654 466.092 254.617 465.736 255.135Z",
    fill: "#FD8715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 68",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.971 250.141C479.971 250.141 479.44 253.018 481.763 253.018C484.085 253.018 499.665 253.527 501.774 252.617C503.884 251.708 503.251 250.141 503.251 250.141H479.971Z",
    fill: "#FFF6E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.078 269.604L459.219 269.533C467.714 265.323 472.817 265.137 474.527 268.975C476.738 273.937 471.004 285.858 457.327 304.74C455.448 299.013 452.746 293.553 453.071 289.637C453.322 286.681 455.988 277.832 459.078 269.604Z",
    fill: "black",
    fillOpacity: 0.159856
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.413 255.658C402.413 255.658 400.883 252.36 398.477 251.468C396.072 250.576 392.393 244.665 392.962 242.949C393.531 241.233 398.507 236.473 398.507 236.473C398.507 236.473 394.108 224.753 396.056 223.43C397.777 222.261 404.291 237.023 404.291 237.023C404.291 237.023 408.121 237.596 409.004 239.106C411.232 242.91 409.548 251.468 409.548 251.468L432.156 284.267L421.782 297.472L402.413 255.658Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M460.125 258.201C452.479 264.945 433.777 282.836 433.777 282.836C433.777 282.836 430.999 278.609 430.999 278.609L417.013 292.828C417.013 292.828 427.563 308.364 430.999 308.473C439.95 308.756 455.989 291.976 471.068 278.874C484.588 267.126 474.377 245.631 460.125 258.201Z",
    fill: "#FD8715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.832 282.857C433.832 282.857 428.586 288.881 428.153 288.224C427.72 287.567 432.11 280.244 432.11 280.244L433.832 282.857Z",
    fill: "black",
    fillOpacity: 0.159856
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 69",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.673 279.567L416.452 297.472L411.454 287.254L429.587 275.957L432.673 279.567Z",
    fill: "#FFEDC2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.835 199.45C491.835 199.45 496.429 193.51 501.733 195.069C507.037 196.627 511.834 206.18 509.556 215.159C507.29 224.14 509.159 229.262 511.909 235.315C519.295 251.595 493.721 261.933 493.721 261.933C493.721 261.933 495.717 249.869 491.835 242.584C487.838 235.082 485.568 225.461 485.568 219.574C485.568 209.336 491.835 199.45 491.835 199.45Z",
    fill: "#8B5030"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.338 134.277C452.818 123.705 471.55 124.331 490.493 134.277L489.293 147.546C487.666 165.529 477.722 181.716 462.415 191.295V191.295V191.295C446.446 181.783 436.213 164.989 435.08 146.435L434.338 134.277Z",
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_13",
    cx: 462.416,
    cy: 155.723,
    rx: 15.315,
    ry: 15.2049,
    fill: "#1CA258"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.197 144.922C467.068 144.922 471.284 148.181 472.507 152.778C472.602 153.133 472.388 153.497 472.031 153.591C471.673 153.685 471.306 153.473 471.212 153.118C470.143 149.102 466.456 146.252 462.197 146.252C457.048 146.252 452.875 150.381 452.875 155.472C452.875 158.346 453.824 160.929 455.734 163.247C455.969 163.531 455.927 163.95 455.64 164.183C455.354 164.415 454.932 164.374 454.697 164.089C452.593 161.537 451.535 158.656 451.535 155.472C451.535 149.645 456.309 144.922 462.197 144.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M459.827 148.663C463.619 147.367 467.713 149.243 469.112 152.912L469.188 153.122C469.907 155.195 470.885 156.133 472.136 156.117C472.506 156.112 472.81 156.406 472.814 156.774C472.819 157.141 472.523 157.443 472.153 157.447C470.288 157.471 468.903 156.203 468.011 153.807L467.921 153.555C466.843 150.448 463.432 148.838 460.263 149.921C457.41 150.896 455.885 154.344 456.556 157.383C456.686 157.975 456.851 158.506 457.064 159.018L457.255 159.46C457.891 160.856 458.718 161.903 462.454 166.36C462.69 166.643 462.652 167.062 462.367 167.297C462.083 167.532 461.66 167.493 461.423 167.211L459.42 164.808C457.016 161.896 456.473 161.066 455.867 159.626L455.825 159.525C455.582 158.939 455.393 158.334 455.246 157.668C454.441 154.017 456.272 149.879 459.827 148.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.375 152.255C463.339 151.583 465.512 152.632 466.122 154.593C467.003 157.418 468.623 159.173 471.015 159.927C471.368 160.038 471.563 160.412 471.451 160.762C471.339 161.112 470.962 161.306 470.61 161.195C467.779 160.303 465.847 158.21 464.842 154.986C464.458 153.753 463.07 153.083 461.811 153.513C460.471 153.971 459.808 155.254 460.174 157.01C460.359 157.903 461.094 159.119 462.345 160.703L462.558 160.971C462.734 161.19 462.918 161.414 463.118 161.653L465.271 164.182C465.507 164.465 465.467 164.885 465.182 165.119C464.897 165.353 464.474 165.313 464.238 165.03L462.516 163.012L462.085 162.501C461.881 162.256 461.692 162.026 461.511 161.801L461.077 161.252C459.831 159.642 459.089 158.372 458.861 157.279C458.364 154.891 459.373 152.939 461.375 152.255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M462.568 155.878C462.922 155.77 463.296 155.968 463.405 156.319C464.127 158.66 465.541 160.321 468.201 162.304C468.497 162.524 468.557 162.941 468.335 163.235C468.113 163.529 467.693 163.588 467.397 163.368C464.531 161.231 462.944 159.368 462.123 156.709C462.015 156.358 462.214 155.986 462.568 155.878Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0.563437,
    y: 221.051,
    width: 109.866,
    height: 109.487,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71828,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 542.852,
    y: 390.637,
    width: 85.9313,
    height: 85.6648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.07742,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 307.478,
    y: 135.738,
    width: 186.818,
    height: 220.612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0862745 0 0 0 0 0.113725 0 0 0 0 0.192157 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd",
    x: 347.798,
    y: 162.812,
    width: 106.341,
    height: 107.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0755213 0 0 0 0 0.582569 0 0 0 0 0.878793 0 0 0 0.229458 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.503982 0 0 0 0 0.700178 0 0 0 0 1 0 0 0 0.233829 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 299.098,
    y1: 320.699,
    x2: 299.098,
    y2: 251.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC967"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 290.964,
    y1: 293.294,
    x2: 290.964,
    y2: 261.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAD4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 502.994,
    y1: 290.908,
    x2: 507.069,
    y2: 361.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 512.463,
    y1: 538.098,
    x2: 514.125,
    y2: 557.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 462.622,
    y1: 536.167,
    x2: 464.195,
    y2: 556.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 462.262,
    y1: 204.745,
    x2: 465.66,
    y2: 250.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 386.111,
    y1: 205.324,
    x2: 396.752,
    y2: 292.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCA1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordDark);
export default __webpack_public_path__ + "static/media/forgot-password-dark.5349f5b051582631b36eca482e4b6d5b.svg";
export { ForwardRef as ReactComponent };